/**
 * 律所 ERP（Track F）Admin 前端路由前缀。
 * 与「律师平台」/lawyer 并列顶级；组件仍在 views/lawyer/firm/**，API 仍 /lawyer/firm/**。
 */
export const FIRM_ERP_ROUTE_BASE = '/lawyer-firm'

/** @param leaf 如 `customer` / `/customer` / `admin-notice` */
export function firmErpPath(leaf: string): string {
  const seg = String(leaf || '')
    .replace(/^\/+/, '')
    .replace(/^lawyer-firm\//, '')
    .replace(/^lawyer\/firm\//, '')
  return `${FIRM_ERP_ROUTE_BASE}/${seg}`
}
